import { render, staticRenderFns } from "./copy_to_clipboard.vue?vue&type=template&id=19d00fd6&scoped=true&"
import script from "./copy_to_clipboard.vue?vue&type=script&lang=js&"
export * from "./copy_to_clipboard.vue?vue&type=script&lang=js&"
import style0 from "./copy_to_clipboard.vue?vue&type=style&index=0&id=19d00fd6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19d00fd6",
  null
  
)

export default component.exports